module.exports = __webpack_public_path__ + "public/img/wjzz.4416ad8a.png";